import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useOTPVerificationAPI = () => {
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (email: string, otp: string) => {
      dispatch(
        setLoading({
          key: "isOTPVerificationInProgress",
          status: true,
        }),
      );
      try {
        const response: string | null = await axios
          .post(
            CUSTOMER_APIS?.OTP_VERIFICATION?.baseURL ?? "",
            {
              email: email,
              otp: otp,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
              withCredentials: true,
            },
          )
          .then((res: AxiosResponse<{ data: { auth_token: string }; message: string; status: boolean }>) => {
            dispatch(
              setLoading({
                key: "isOTPVerificationInProgress",
                status: false,
              }),
            );
            if (res.data.status) {
              return res.data.data;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isOTPVerificationInProgress",
                status: false,
              }),
            );
            captureError(e);
            return null;
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return null;
      }
    },
    [dispatch],
  );
  return { execute };
};
